// PasswordGate — global modal that blocks the app until placeholder password is changed.
import { useState } from "react";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import { ShieldAlert, KeyRound } from "lucide-react";
import { toast } from "sonner";

export default function PasswordGate() {
  const { user, refresh, logout } = useAuth();
  const [cur, setCur] = useState("");
  const [next1, setNext1] = useState("");
  const [next2, setNext2] = useState("");
  const [busy, setBusy] = useState(false);

  if (!user || !user.password_change_required) return null;

  const submit = async () => {
    if (next1.length < 8) { toast.error("New password must be at least 8 characters"); return; }
    if (next1 !== next2) { toast.error("New passwords don't match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: next1 });
      toast.success("Password updated · welcome to NEXUS");
      await refresh();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed to change password");
    }
    setBusy(false);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-md p-6" data-testid="password-gate">
      <div className="glass-strong w-full max-w-md p-6 space-y-4 border-l-2 border-nexus-gold">
        <div className="flex items-center gap-2">
          <ShieldAlert className="w-5 h-5 text-nexus-gold" />
          <div className="label-eyebrow text-nexus-gold">// first-login security gate</div>
        </div>
        <h2 className="font-display font-black text-2xl">Set your password to continue</h2>
        <p className="text-xs text-white/60 leading-relaxed">
          Hi <strong className="text-nexus-cyan">{user.display_name}</strong> — this is a placeholder account. Please pick a real password (8+ chars) before you can use NEXUS.
        </p>
        <div className="space-y-2">
          <input type="password" value={cur} onChange={(e) => setCur(e.target.value)}
            placeholder="Current (placeholder) password"
            className="w-full bg-transparent border border-white/10 px-3 py-2 text-sm" data-testid="pg-current" />
          <input type="password" value={next1} onChange={(e) => setNext1(e.target.value)}
            placeholder="New password (8+ characters)"
            className="w-full bg-transparent border border-white/10 px-3 py-2 text-sm" data-testid="pg-new" />
          <input type="password" value={next2} onChange={(e) => setNext2(e.target.value)}
            placeholder="Confirm new password"
            className="w-full bg-transparent border border-white/10 px-3 py-2 text-sm" data-testid="pg-confirm" />
        </div>
        <div className="flex gap-2">
          <button onClick={submit} disabled={busy} className="btn-nexus flex-1 justify-center" data-testid="pg-submit">
            <KeyRound className="w-3.5 h-3.5" /> {busy ? "Updating…" : "Set password"}
          </button>
          <button onClick={logout} className="btn-ghost" data-testid="pg-logout">Sign out</button>
        </div>
      </div>
    </div>
  );
}
